import type { ReactElement } from "react"

import { AccountForm } from "./components/AccountForm"
import { OrganizationForm } from "./components/OrganizationForm"

import styles from "./Settings.module.scss"

/**
 * `AccountAndOrganization` is a wrapper component that renders both the `AccountForm`
 * and the `OrganizationForm` within a styled container.
 *
 * @returns A ReactElement containing both account and organization forms.
 */
export function AccountAndOrganization(): ReactElement {
  return (
    <div className={styles.container}>
      <AccountForm />

      <OrganizationForm />
    </div>
  )
}
